import React, { FC } from 'react';

import { LucidTheme } from '@lucid/theme';

import Box from '../box/box';
import Heading from '../heading/heading';
import Image from '../image/image';
import Link from '../link/link';
import Text from '../text/text';
import { ComponentLink, ComponentImage } from '../../types/generics';

export interface HeroProps {
  /** The button CTA link and text. */
  cta?: ComponentLink;
  /** The heading text. */
  header: string;
  /** An image to be placed next to the text. */
  image?: ComponentImage;
  /** The subHeading text displayed under the heading text. */
  subheader: string;
}

const Hero: FC<HeroProps> = ({
  cta,
  header,
  image,
  subheader
}) => {
  const hasImage = image && image.imageSrc;

  return (
    <Box
      css={(theme: LucidTheme) => [
        {
          padding: theme.space.s64
        },
        hasImage && {
          display: 'flex',
          justifyContent: 'center'
        }
      ]}
    >
      <Box
        css={(theme: LucidTheme) => [
          hasImage && {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'space-between',
            maxWidth: '440px',
            paddingRight: theme.space.s40
          }
        ]}
      >
        <Heading
          css={[
            hasImage && {
              textAlign: 'left'
            }
          ]}
          textAlign="center"
          variant="headline3XL"
        >
          {header}
        </Heading>
        <Text
          css={[
            hasImage && {
              textAlign: 'left'
            }
          ]}
          textAlign="center"
          variant="paragraphM400"
        >
          {subheader}
        </Text>
        <Box
          css={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          {cta && cta.linkUrl && (
            <Link displayAsButton href={cta.linkUrl} variant="primaryAlternate">
              {cta.linkText}
            </Link>
          )}
        </Box>
      </Box>
      {image && image.imageSrc && (
        <Box
          css={[
            hasImage && {
              width: '580px'
            }
          ]}
        >
          <Image
            alt={image.imageAlt}
            aspectRatio="4:3"
            src={image.imageSrc}
          />
        </Box>
      )}
    </Box>
  );
};

export { Hero };
export default Hero;
